export default {"src":"__ASTRO_ASSET_IMAGE__DPKb97bz__","width":1052,"height":1056,"format":"png"}